// this file and all imported files are cached client side for 1 year, always. The loader is there to bust the cache.

import { initialize } from './ts/actions';
import { log } from './ts/helpers';
import { LOG_PREFIX } from './ts/resources';

window.Bookmarking = {
  init: (brandName: BrandName) => {
    try {
      (async (brandArg: BrandName) => {
        const brand = brandArg || window.APP?.config?.brandName;
        log(
          `brandArg: ${brandArg}, APP.config.brandName: ${window.APP?.config?.brandName} `
        );
        if (!brand)
          throw new Error(
            'Could not find a brand name to initialize with. Please pass a brandName string to window.Bookmarking.init'
          );
        log('initializing as', brand);
        await initialize(brand);
      })(brandName);
    } catch (ex) {
      console.error(LOG_PREFIX, ex);
    }
  },
};
